import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { StateComponent } from './state.component';
import { StateRoutingModule } from './state.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    StateRoutingModule,
  ],
  exports: [
    StateComponent
  ],
  declarations: [
    StateComponent
  ],
})
export class StateModule { }
